export const customCalendar = {
  name: 'Custom',
  months: [
    {
      name: 'Custom Month',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    // {
    //   name: 'January',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'February',
    //   days: 28,
    //   leapDays: 1,
    //   leapPeriod: 4,
    // },
    // {
    //   name: 'March',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'April',
    //   days: 30,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'May',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'June',
    //   days: 30,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'July',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'August',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'September',
    //   days: 30,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'October',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'November',
    //   days: 30,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
    // {
    //   name: 'December',
    //   days: 31,
    //   leapDays: 0,
    //   leapPeriod: 0,
    // },
  ],
  time: {
    minute: {
      name: 'Minute',
      plural: 'Minutes',
      duration: '60',
    },
    hour: {
      name: 'Hour',
      plural: 'Hours',
      duration: '3600',
    },
    day: {
      name: 'Day',
      plural: 'Days',
      duration: '86400',
    },
    month: {
      name: 'Month',
      plural: 'Months',
    },
    year: {
      name: 'Year',
      plural: 'Years',
      duration: '31536000',
    },
    decade: {
      name: 'Decade',
      plural: 'Decades',
      enabled: true,
      duration: '315360000',
    },
    century: {
      name: 'Century',
      plural: 'Centuries',
      enabled: true,
      duration: '3153600000',
    },
    millenium: {
      name: 'Millenium',
      plural: 'Millenia',
      enabled: true,
      duration: '31536000000',
    },
    myriad: {
      name: 'Myriad',
      plural: 'Myriads',
      enabled: true,
      duration: '315360000000',
    },
    epoch: {
      name: 'Epoch',
      plural: 'Epochs',
      enabled: true,
      duration: '3153600000000',
    },
    aeon: {
      name: 'Aeon',
      plural: 'Aeons',
      enabled: true,
      duration: '31536000000000',
    },
  },
};
